import linkedIn from '../../assets/images/linkedin.png'
import email from '../../assets/images/email.png'
import file from '../../assets/images/file.png'
import resume from '../../assets/documents/resume.pdf'

import homeDecor from '../../assets/images/homeDecor.jpg'
import cozyproto from '../../assets/images/cozyproto.gif'
import cs1 from '../../assets/images/cs_01.png'
import cs2 from '../../assets/images/cs_02.png'
import cs3 from '../../assets/images/cs_03.png'
import cs4 from '../../assets/images/cs_04.png'
import cs5 from '../../assets/images/cs_05.png'
import cs6 from '../../assets/images/cs_06.png'
import cs7 from '../../assets/images/cs_07.png'
import cs8 from '../../assets/images/cs_08.png'
import cs9 from '../../assets/images/cs_09.png'
import cs10 from '../../assets/images/cs_010.png'
import cs11 from '../../assets/images/cs_011.png'
import cs12 from '../../assets/images/cs_012.png'
import cs13 from '../../assets/images/cs_013.png'
import cs14 from '../../assets/images/cs_014.png'
import cs15 from '../../assets/images/cs_015.png'
import cs16 from '../../assets/images/cs_016.png'
import cs17 from '../../assets/images/cs_017.png'
import cs18 from '../../assets/images/cs_018.png'

import bakeryMobile from '../../assets/images/bakeryMobile.jpg'
import app1 from '../../assets/images/app1.jpg'
import app2 from '../../assets/images/app2.jpg'
import appresearch from '../../assets/images/appresearch.jpg'
import appperson1 from '../../assets/images/appperson1.jpg'
import appperson2 from '../../assets/images/appperson2.jpg'
import appmap from '../../assets/images/appmap.jpg'
import applofi from '../../assets/images/applofi.jpg'
import applofi2 from '../../assets/images/applofi2.jpg'
import appmock from '../../assets/images/appmock.jpg'
import appmock2 from '../../assets/images/appmock2.jpg'
import appproto from '../../assets/images/appproto.gif'

import bakeryWeb from '../../assets/images/bakeryWeb.jpg'
import web1 from '../../assets/images/web1.png'
import web2 from '../../assets/images/web2.png'
import web3 from '../../assets/images/web3.png'
import webpersona from '../../assets/images/webpersona.png'
import webia from '../../assets/images/webia.png'
import webmap from '../../assets/images/webmap.png'
import weblofi1 from '../../assets/images/weblofi1.png'
import weblofi2 from '../../assets/images/weblofi2.png'
import webhome from '../../assets/images/webhome.png'
import webpdp from '../../assets/images/webpdp.png'
import weborder from '../../assets/images/weborder.png'
import webmock from '../../assets/images/webmock.gif'


import inner from '../../assets/images/inner.png'
import chrome from '../../assets/images/chrome.png'
import pearls from '../../assets/images/pearl.gif'
import shiny from '../../assets/images/pinkAndGreen.gif'
import wave from '../../assets/images/wave.gif'
import pinkPool from '../../assets/images/pinkPool.png'

import ht from '../../assets/images/ht.jpg'
import ht1 from '../../assets/images/ht_01.png'
import ht2 from '../../assets/images/ht_02.png'
import ht3 from '../../assets/images/ht_03.png'
import ht4 from '../../assets/images/ht_04.png'
import ht5 from '../../assets/images/ht_05.png'
import ht6 from '../../assets/images/ht_06.png'
import ht7 from '../../assets/images/ht_07.png'
import ht8 from '../../assets/images/ht_08.png'
import ht9 from '../../assets/images/ht_09.png'
import ht10 from '../../assets/images/ht_010.png'
import ht11 from '../../assets/images/ht_011.png'
import ht12 from '../../assets/images/ht_012.png'
import ht13 from '../../assets/images/ht_013.png'
import ht14 from '../../assets/images/ht_014.png'

import ch1 from '../../assets/images/ch_01.png'
import ch2 from '../../assets/images/ch_02.png'
import ch3 from '../../assets/images/ch_03.png'
import ch4 from '../../assets/images/ch_04.png'
import ch5 from '../../assets/images/ch_05.png'
import ch6 from '../../assets/images/ch_06.png'
import ch7 from '../../assets/images/ch_07.png'

export const NavItems = [
    {
        title: 'Home',
        url: "/",
        cName: "nav-links"
    },
    {
        title: 'Work',
        url: "/work",
        cName: "nav-links"
    },
    {
        title: 'About',
        url: "/about",
        cName: "nav-links"
    },
]

export const footerItems = [
    {
        title: 'Email',
        image: email,
        url: 'mailto:jessicahchoi93@gmail.com',
        cName: 'footer-links'
    }, 
    {
        title: 'Resume',
        image: file,
        url: resume,
        cName: 'footer-links'
    },
    {
        title: 'LinkedIn',
        image: linkedIn,
        url: 'https://www.linkedin.com/in/heyyoungaa',
        cName: 'footer-links'
    }
]

export const projects = [
    {
        id: 'harris-teeter-redesign',
        number: 1,
        cover: ht,
        title: 'Harris Teeter Mobile App Redesign',
        cName: 'case-links',
        tags: 'App Design',
        images: [
            {
                image: ht1,
                alt: 'harris teeter redesign case study cover page'
            },
            {
                image: ht2,
                alt: 'harris teeter redesign project objectives'
            },
            {
                image: ht3,
                alt: 'why it matters that online grocery platforms are designed with clarity and efficiency'
            },
            {
                image: ht4,
                alt: 'general information on harris teeter, target users and purpose for redesign'
            },
            {
                image: ht5,
                alt: 'overall design thinking process explained '
            },
            {
                image: ht6,
                alt: 'reserach methods conducted to identify user pain points'
            },
            {
                image: ht7,
                alt: 'key insights on discoverability, information hierarchy and task flow issues'
            },
            {
                image: ht8,
                alt: 'before and wireframe of home screen with comments'
            },
            {
                image: ht9,
                alt: 'before and wireframe of save screen with comments'
            },
            {
                image: ht10,
                alt: 'before and wireframe of weekly ad screen with comments'
            },
            {
                image: ht11,
                alt: 'final mockups of home screen with comments'
            },
            {
                image: ht12,
                alt: 'final mockups of save screen with comments'
            },
            {
                image: ht13,
                alt: 'final mockups of weekly ad screen with comments'
            },
            {
                image: ht14,
                alt: 'next steps for the harris teeter redesign case'
            }
        ]
    },
    {
        id: 'home-shopping-concept',
        number: 2,
        cover: homeDecor,
        title: 'Cozy Space — Accessible Furniture Mobile Experience ',
        cName: 'case-links',
        tags: 'App Design',
        images: [
            {
                image: cs1,
                alt: 'cozy space case study cover slide'
            },
            {
                image: cs2,
                alt: 'cozy space case study objectives'
            },
            {
                image: cs3,
                alt: 'definition of accessible furniture, who uses it and why the market is underserved'
            },
            {
                image: cs4,
                alt: 'design thinking process'
            },
            {
                image: cs5,
                alt: 'public opinions on accessible furniture'
            },
            {
                image: cs6,
                alt: 'competitive analysis with houzz, wayfair and stander'
            },
            {
                image: cs7,
                alt: 'affinity map'
            },
            {
                image: cs8,
                alt: 'key insights'
            },
            {
                image: cs9,
                alt: 'early sketches and focus areas'
            },
            {
                image: cs10,
                alt: 'low fidelity mockups'
            },
            {
                image: cs11,
                alt: 'final mockup screen for home page'
            },
            {
                image: cs12,
                alt: 'final mockup screen for search and filter'
            },
            {
                image: cs13,
                alt: 'final mockup screen of product detail page'
            },
            {
                image: cs14,
                alt: 'additional mockup screens'
            },
            {
                image: cs15,
                alt: 'additional mockup screens'
            },
            {
                image: cozyproto,
                alt: 'prototype walkthrough'
            },
            {
                image: cs16,
                alt: 'site map of web platform'
            },
            {
                image: cs17,
                alt: 'responsive web layouts across phone, ipad and laptop'
            },
            {
                image: cs18,
                alt: 'next steps if the conceptual project were to launch'
            },
        ]
    },
    {
        id: 'bakery-website-concept',
        number: 3,
        cover: bakeryWeb,
        title: 'Bakery Website',
        cName: 'case-links',
        tags: 'Web Design',
        images: [
            {
                image: web1,
                alt: 'bakery website study page'
            },
            {
                image: web2,
                alt: 'bakery website study page'
            },
             {
                image: web3,
                alt: 'bakery website study page'
            },
            {
                image: webpersona,
                alt: 'bakery website study page'
            },
            {
                image: webmap,
                alt: 'bakery website study page'
            },
                {
                image: webia,
                alt: 'bakery website study page'
            },
            {
                image: weblofi1,
                alt: 'bakery website study page'
            },
            {
                image: weblofi2,
                alt: 'bakery website study page'
            },
            {
                image: webhome,
                alt: 'bakery website study page'
            },
            {
                image: webpdp,
                alt: 'bakery website study page'
            },
            {
                image: weborder,
                alt: 'bakery website study page'
            },
            {
                image: webmock,
                alt: 'bakery website study page'
            }
        ]

    },
    {
        id: 'bakery-app-concept',
        number: 4,
        cover: bakeryMobile,
        title: 'Bakery Mobile App',
        cName: 'case-links',
        tags: 'App Design',
        images: [
            {
                image: app1,
                alt: 'bakery app study page'
            },
            {
                image: app2,
                alt: 'bakery app study page'
            },
            {
                image: appresearch,
                alt: 'bakery app study page'
            },
            {
                image: appperson1,
                alt: 'bakery app study page'
            },
            {
                image: appperson2,
                alt: 'bakery app study page'
            },
            {
                image: appmap,
                alt: 'bakery app study page'
            },
            {
                image: applofi,
                alt: 'bakery app study page'
            },
            {
                image: applofi2,
                alt: 'bakery app study page'
            },
                {
                image: appmock,
                alt: 'bakery app study page'
            },
            {
                image: appmock2,
                alt: 'bakery app study page'
            },
            {
                image: appproto,
                alt: 'bakery app study page'
            }
        ]

    }
]

export const dataProjects = [
    {
        id: 'chicago-housing-analysis',
        title: 'Affordable Housing in Chicago',
        subtitle: `Analyzing the geographic distribution and concentration of affordable housing across Chicago's community areas`,
        cName: 'data-project-links',
        images: [
            {
                image: ch1,
                alt: 'affordable housing in chincago analysis cover'
            },
            {
                image: ch2,
                alt: 'chicago housing analysis objectives'
            },
            {
                image: ch3,
                alt: 'errors found in the dataset and what was cleaned'
            },
            {
                image: ch4,
                alt: 'results '
            },
            {
                image: ch5,
                alt: 'results'
            },
            {
                image: ch6,
                alt: 'source check for the top 10 areas'
            },
            {
                image: ch7,
                alt: 'next steps'
            }
        ]
    },    
]
export const blenderWork = [
    {
        image: inner,
        alt: 'soft orb admist flowers'
    },
    {
        image: shiny,
        alt: 'Shiny'
    },
    { 
        image: chrome,
        alt: 'Chrome Name'
    },
    {
        image: pinkPool,
        alt: 'pink pool space'
    },
    {
        image: wave,
        alt:'gentle ocean waves'
    },
    {
        image: pearls,
        alt: 'Pearls in Space'
    }
]